import { render, staticRenderFns } from "./leadgidOffers.vue?vue&type=template&id=aaf0886c&"
import script from "./leadgidOffers.vue?vue&type=script&lang=js&"
export * from "./leadgidOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports